
import { setToken, removeToken } from '@/utils/sessionStorageUtil.js'
// 登录用户信息及token
const state = {
    token: '',
    name: '',
    avatar: '',
    introduction: '',
    roles: [],
    menus: [],
    userInfo:''
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
        setToken(token)
    },
    SET_MENUS: (state, menus) => {
        state.menus = menus;
    },
    SET_INTRODUCTION: (state, introduction) => {
        state.introduction = introduction
    },
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles
    },
    SET_USERINFO: (state, userInfo) => {
        state.userInfo = userInfo
        state.name = userInfo.name
    }
}

const actions = {

    // remove token
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            removeToken()
            resolve()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}